import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import CompressPDFCompressListScreen from "../compress_pdf/CompressPDFCompressListScreen";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";

function PdfUnder200KBMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Compress PDFs under 200 KB",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: {
      link: "/compress_pdf_under_200_kb",
      title: "Compress PDFs under 200 KB",
    },
    data2: {
      link: "/compress_pdf_under_200_kb",
      title: "Bulk Compress PDF files",
    },
    data3: { link: "/compress_pdf_under_200_kb", title: "PDFs under 200 kB" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Compress PDF under 200KB online easily. Reduce PDF file size for forms, uploads, and emails with our fast, secure PDF compressor tool."
      ></meta>
      <meta
        name="keywords"
        content="compress pdf under 200kb, pdf under 200kb, reduce pdf size to 200kb, compress pdf 200kb, pdf compressor under 200kb, make pdf 200kb, online pdf compressor, shrink pdf to 200kb, pdf size reducer, compress pdf for upload, compress pdf for email, pdf compression tool, reduce pdf file size, small pdf compressor, pdf optimizer"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <CompressPDFCompressListScreen
          title={title}
          scale_resolution={true}
          grayscale={true}
        />
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Compress PDFs under 200KB quickly and effortlessly with our powerful online PDF compressor designed for speed, quality, and convenience. This website helps you reduce PDF file size to 200KB or less without compromising document clarity, making it ideal for online form submissions, email attachments, job applications, government portals, and academic uploads. Using advanced compression algorithms, our PDF compression tool intelligently minimizes file size while preserving text readability, images, and formatting. Whether you need to shrink large PDF files, optimize PDFs for web upload, or meet strict file size limits, our tool delivers reliable results in seconds. No installation or technical skills are required—simply upload your file and compress PDFs online instantly from any device, including mobile, tablet, or desktop. This free PDF compressor supports secure processing, ensuring your files remain private while being compressed efficiently. Perfect for students, professionals, and businesses, our website allows you to reduce PDF size under 200KB, compress large PDFs, and optimize documents for fast sharing and storage. If you’re searching for the best PDF compressor online, reduce PDF file size without losing quality, or a quick solution to make PDF under 200KB, this platform is built to meet all your needs with accuracy and performance." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Compress",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Compress PDF to 200 KB"
            why_use={[
              {
                title: "Meet Online Upload Size Limits",
                description:
                  "Many government portals, job application websites, exam forms, and university submission systems require files to be under 200KB. Using a PDF compressor under 200KB helps you meet these strict upload limits without rejection.",
              },
              {
                title: "Faster File Upload and Download",
                description:
                  "Smaller PDF files upload and download much faster. When you compress PDF to 200KB, it reduces loading time, saves bandwidth, and improves user experience, especially on slow internet connections.",
              },
              {
                title: "Easy Email Sharing",
                description:
                  "Large PDFs often fail to send via email. By using a PDF size reducer, you can easily compress PDF files under 200KB and share documents quickly without email attachment issues.",
              },

              {
                title: "Save Device Storage Space",
                description:
                  "Compressed PDFs take up less storage on your mobile, tablet, or computer. A PDF compression tool helps reduce file size and keeps your device storage organized and efficient.",
              },
              {
                title: "Better Compatibility Across Platforms",
                description:
                  "Many websites and apps accept only lightweight files. When you reduce PDF file size under 200KB, your documents become compatible with more platforms and systems.",
              },
              {
                title: "No Loss of Document Quality",
                description:
                  "This online PDF compressor tools use smart compression techniques that maintain text clarity and readability while reducing file size, ensuring professional-quality documents.",
              },
              {
                title: "Ideal for Students and Professionals",
                description:
                  "Students submitting assignments and professionals uploading resumes often need to make PDF under 200KB. A reliable PDF compressor online simplifies this task in seconds.",
              },
              {
                title: "Improves Website Performance",
                description:
                  "Smaller PDFs load faster on websites, improving page speed and SEO performance. Using compressed PDFs under 200KB helps optimize web content and user engagement.",
              },
              {
                title: "Secure and Hassle-Free Process",
                description:
                  "Our PDF compression websites offer secure processing without compromising file privacy. You can compress PDF online safely without installing any software.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1609168763}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default PdfUnder200KBMain;
